
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physician-finder/[...slug]",
      function () {
        return require("private-next-pages/physician-finder/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physician-finder/[...slug]"])
      });
    }
  